import React from "react";
import { Box, Typography } from "@mui/material";

const BusinessProfilePDFView = React.forwardRef(({ data }, ref) => {
  return (
    <Box ref={ref} sx={{ padding: 4, fontFamily: "Arial", color: "#000" }}>
      <Typography
        variant="h5"
        align="center"
        sx={{ fontWeight: "bold", color: "#002366", mb: 1 }}
      >
        {data?.enterpriseName}
      </Typography>
      <Typography
        align="center"
        sx={{ fontWeight: "bold", color: "#002366" }}
      >
        {data?.address}
      </Typography>
      <Typography align="center" sx={{ fontWeight: "bold", color: "#002366" }}>
        PH-NO : {data?.mobileNumber}
      </Typography>
      <Typography
        align="center"
        sx={{ fontWeight: "bold", color: "#002366", mb: 4 }}
      >
        {data?.emailId}
      </Typography>

      <Section title="Specialization" content={data?.specialization} />
      <Section title="Achievements" content={data?.achievements || "-"} />
      <Section title="Overview" content={data?.overview || "-"} />
      <Section
        title="TERMS AND CONDITIONS"
        content={data?.termsAndConditions || "-"}
      />
    </Box>
  );
});

const Section = ({ title, content }) => (
  <Box sx={{ mt: 4 }}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: "bold", color: "#002366" }}
    >
      {title}
    </Typography>
    <Typography
      variant="body2"
      sx={{ mt: 1, fontWeight: "bold", fontStyle: "italic" }}
    >
      {content}
    </Typography>
  </Box>
);

export default BusinessProfilePDFView;
